export default function () {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z"
                fill="url(#paint0_linear_4813_14039)"
            />
            <g filter="url(#filter0_di_4813_14039)">
                <path
                    d="M55.4687 35.3078L47.6398 39.364C47.3089 39.5359 46.905 39.4242 46.7117 39.1062L40.5972 29.2191C40.5714 29.1804 40.5328 29.1632 40.507 29.1332C41.564 28.9011 42.3546 27.9601 42.3546 26.8343C42.3546 25.5324 41.2976 24.4753 39.9956 24.4753C38.6937 24.4753 37.6367 25.5324 37.6367 26.8343C37.6367 27.9601 38.4273 28.9011 39.4843 29.1332C39.4542 29.1632 39.4156 29.1804 39.3941 29.2191L33.2796 39.1062C33.0863 39.4199 32.6781 39.5316 32.3515 39.364L24.5226 35.3078C23.9984 35.0371 23.3882 35.4882 23.4999 36.0726L26.164 49.8656C26.2285 50.2007 26.5206 50.4414 26.8601 50.4414H53.1355C53.4749 50.4414 53.7671 50.2007 53.8316 49.8656L56.4913 36.0683C56.6031 35.4882 55.9972 35.0328 55.4687 35.3078ZM53.0324 52.3921H26.9589C26.5808 52.3921 26.2714 52.6972 26.2714 53.0796V54.7339C26.2714 55.1121 26.5765 55.4214 26.9589 55.4214H53.0324C53.4105 55.4214 53.7199 55.1164 53.7199 54.7339V53.0796C53.7199 52.6972 53.4105 52.3921 53.0324 52.3921Z"
                    fill="url(#paint1_linear_4813_14039)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_4813_14039"
                    x="20.9866"
                    y="21.9753"
                    width="38.0183"
                    height="35.946"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.25" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.972511 0 0 0 0 0.889864 0 0 0 0 0.703908 0 0 0 0.8 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4813_14039" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4813_14039" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.3" />
                    <feGaussianBlur stdDeviation="0.55" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_4813_14039" />
                </filter>
                <linearGradient id="paint0_linear_4813_14039" x1="13.232" y1="10.6479" x2="72.5096" y2="75.9879" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#714200" />
                    <stop offset="0.5" stopColor="#966A2C" />
                    <stop offset="1" stopColor="#714200" />
                </linearGradient>
                <linearGradient id="paint1_linear_4813_14039" x1="23.4866" y1="25.2539" x2="61.6144" y2="37.0789" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFF6E1" />
                    <stop offset="1" stopColor="#FFE4AC" />
                </linearGradient>
            </defs>
        </svg>
    );
}
